<p>
  view-designerportfolio works!
</p>



// WEBPACK FOOTER //
// ./src/app/platform/organisation/designer_portfolio/view-designerportfolio/view-designerportfolio.component.html